module.exports = __webpack_public_path__ + "static/product-family-home-extra extra-vanilla-aec86652ac94e3f187f864e06b31e3ce.png";